import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import 'NOTICEBOARD/CommonResources/RoutingMenu/routemenu.css';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';

const RouteMenu = (props) => {
    // VARIABLES TO SHOW ROUTING MENU
    const [activeScreen, setActiveScreen] = useState(props.activeScreen);
    const noticeScreens = ['notices', 'postnotice', 'grantaccess', 'reports'];
    
    //GET TEMPLATE DATA
    const routingMenu = useSelector((state) => state.RouteMenuReducer);

    const dispatch = useDispatch();

    useEffect(() => {
        if(noticeScreens.includes(activeScreen)) {
            dispatch({ type: 'SET_SIDE_MENU_NAVIGATION', sideMenuNavigation: false });
        }else {
            dispatch({ type: 'SET_SIDE_MENU_NAVIGATION', sideMenuNavigation: true });
        }
    }, []);

    const navScreens = [
        {
            name: "Notices",
            url: `/noticeboard`,
            activeScreen: 'notices',
            icon: <FontAwesomeIcon icon={['fas', 'clipboard-list']} size="lg" />,
            isAccessible: true
        },
        {
            name: "Post Notice",
            url: '/postnotice',
            activeScreen: 'postnotice',
            icon: <FontAwesomeIcon icon={['fas', 'envelope-open-text']} size="lg" />,
            isAccessible: routingMenu.isNoticeAdmin
        },
        {
            name: "Grant Access",
            url: '/grantaccess',
            activeScreen: 'grantaccess',
            icon: <FontAwesomeIcon icon={['fas', 'user-lock']} size="lg" />,
            isAccessible: routingMenu.isCategoryAdmin
        },
        {
            name: "Reports",
            url: '/reports/allReports',
            activeScreen: 'reports',
            icon: <FontAwesomeIcon icon={['fas', 'file-signature']} size="lg" />,
            isAccessible: routingMenu.isCategoryAdmin
        }
    ];

    return (
        <div>
            <div className={routingMenu.expandRouteMenu ? "routingMenuExpanded" : 'routingMenu'}>
                <div className="routing-menu" id="routing-menu" onMouseOver={() => dispatch({ type: 'TOGGLE_ROUTE_MENU', toggleFlag: true })} onMouseLeave={() => dispatch({ type: 'TOGGLE_ROUTE_MENU', toggleFlag: false })}>
                {
                        navScreens.map((menu, index) => {
                            if(routingMenu.expandRouteMenu) {
                                if(menu.isAccessible) {
                                    return (
                                        <Link to={menu.url} style={{ textDecoration: 'none' }}>
                                            <span className={(props.activeScreen == menu.activeScreen) ? "dropdown-item sideMenu-item-name selected" : "dropdown-item sideMenu-item-name"} title={`Click here to view ${menu.name}`} onClick={() => (menu.activeScreen == 'setting') && (typeof props.closeSettingLinks == 'function' && props.closeSettingLinks())}>
                                                <p className="routeMenuIcon">{menu.icon}</p>
                                                <p className="routeMenuName">{menu.name}</p>
                                            </span>
                                        </Link>
                                    );
                                }
                            }else {
                                if(menu.isAccessible) {
                                    return (
                                        <Link to={menu.url} style={{ textDecoration: 'none' }}>
                                            <span className={(props.activeScreen == menu.activeScreen) ? "dropdown-item sideMenu-item selected" : "dropdown-item sideMenu-item "} title={`Click here to view ${menu.name}`} onClick={(e) => (menu.activeScreen == 'setting') && (typeof props.closeSettingLinks == 'function' && props.closeSettingLinks())}>
                                                {menu.icon}
                                            </span>
                                        </Link>
                                    );
                                }
                            }
                        })
                    }
                </div>
            </div>
            <div className="dropdown settingMenu col-md-12" style={{ paddingLeft: 5 }}>
                <p className="menuDropdownButton dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <FontAwesomeIcon icon={['fas', 'bars']} />
                </p>
                <div className="dropdown-menu setting-dropdown-menu" aria-labelledby="dropdownMenuButton">
                    {
                            navScreens.map((menu, index) => {
                                if(menu.isAccessible) {
                                    return (
                                        <Link to={menu.url} style={{ textDecoration: 'none' }}>
                                            <span className={props.activeScreen == menu.activeScreen ? "dropdown-item sideMenu-item-name selected" : "dropdown-item sideMenu-item-name"} title={`Click here to view ${menu.name}`} onClick={() => { setActiveScreen(menu.activeScreen); if(typeof props.closeSettingLinks == 'function') { props.closeSettingLinks() } }}>
                                                <p className="routeMenuIcon">{menu.icon}</p>
                                                <p className="routeMenuName">{menu.name}</p>
                                            </span>
                                        </Link>
                                    );
                                }
                            })
                        }
                </div>
            </div>
        </div>
    );
}

export default RouteMenu;
